import { JSX } from 'react';
import { FieldValues } from 'react-hook-form';
import { CommonFieldProps } from '../form.types';
import { FormField } from '../form-field';
import type { ExchangeId } from '@shared/types';

const exchanges: ExchangeId[] = ['BYBIT', 'BINANCE'];

export type ExchangeFieldProps<T extends FieldValues> = Omit<
  CommonFieldProps<T>,
  'label'
> & {
  type: 'exchange';
  onChange: (
    event: React.SyntheticEvent<Element, Event>,
    value: string | string[] | null
  ) => void;
  label?: string;
};

export const ExchangeField = <T extends FieldValues>({
  name,
  onChange,
  label = 'Exchange'
}: ExchangeFieldProps<T>): JSX.Element => {
  return (
    <FormField
      type="autocomplete"
      name={name}
      label={label}
      options={exchanges}
      onChange={onChange}
      noWrapper={true}
    />
  );
};
